import { render, staticRenderFns } from "./ListDistributionCenterPackingDirectLinkBranchTab.vue?vue&type=template&id=5d5245a1"
import script from "./ListDistributionCenterPackingDirectLinkBranchTab.vue?vue&type=script&lang=js"
export * from "./ListDistributionCenterPackingDirectLinkBranchTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports